<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<h2>
					{{ block.block_title }}
				</h2>
			</div>

			<ul class="short_announce_list">
				<li v-for="(item, index) in block.items" :key="index" class="row">
					<PanelLi01Image :item="item" :index="index" :block-id="block.id" />
					<div class="col-12 col-md-7 col-lg-8">
						<div class="announce_content_block border-md-top">
							<div class="announce_content_header">
								<div v-if="item.description" class="title">
									{{ item.description }}
								</div>
								<div v-if="item.text" class="description" v-html=" item.text" />
							</div>
							<div class="announce_content_footer">
								<parse-snippets :content="item.bottom_buttons" />
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import PanelLi01Image from '@/components/panels/LI/PanelLi01Image.vue';
import ParseSnippets from '~/components/snippets/ParseSnippets.vue';
import panel from '~/mixins/panel';

export default {
	name: 'CampusHotelsList',
	components: {
		ParseSnippets,
		PanelLi01Image,
	},
	mixins: [panel],
};

</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/short-announce-list";
</style>
